<template>
<div>
  <check-vin-bar v-if="showBottomVinCheckUrl.includes($route.path)"></check-vin-bar>
  <footer class="site-footer">
    <div class="site-footer__inner">
      <div class="site-footer__navigation">
        <section class="site-footer__column">
          <h3 class="site-footer__column-title">Sample Reports</h3>
          <ul class="site-footer__link-list">
            <li class="site-footer__link-item" @click="navigationTo('/sample-reports')">Vehicle History Report</li>
          </ul>
        </section>

        <section class="site-footer__column">
          <h3 class="site-footer__column-title">Chinese Vehicle History</h3>
          <ul class="site-footer__link-list">
            <li class="site-footer__link-item" @click="navigationTo('/vehicle-history/introduction')">Introduction</li>
            <li class="site-footer__link-item" @click="navigationTo('/vehicle-history/vin-introduction')">VIN Number</li>
            <li class="site-footer__link-item" @click="navigationTo('/vehicle-history/vin-check')">VIN Check</li>
            <li class="site-footer__link-item" @click="navigationTo('/vehicle-history/how-to-buy')">How to buy</li>
          </ul>
        </section>

        <section class="site-footer__column site-footer__column--service">
          <h3 class="site-footer__column-title">Customer Service</h3>
          <div class="site-footer__contact-group">
            <div class="site-footer__contact-link" @click="openWhatsApp">
              <img :src="footerIcon1" class="site-footer__contact-icon" alt="">
              <span class="site-footer__contact-text">WhatsApp Support</span>
            </div>
            <div class="site-footer__contact-label">Contact</div>
            <div class="site-footer__contact-link" @click="openOutlookApp">
              <img :src="footerIcon2" class="site-footer__contact-icon" alt="">
              <span class="site-footer__contact-text">lemoncheck.support@gmail.com</span>
            </div>
          </div>
        </section>

        <section class="site-footer__column">
          <h3 class="site-footer__column-title">For Business</h3>
          <ul class="site-footer__link-list">
            <li class="site-footer__link-item"  @click="navigationTo('/for-business')">For Business</li>
            <!-- <li class="site-footer__link-item">Cooperation</li> -->
          </ul>
        </section>

        <section class="site-footer__column">
          <h3 class="site-footer__column-title">Contact Us</h3>
          <ul class="site-footer__link-list">
            <li class="site-footer__link-item" @click="navigationTo('/contact-us')">Contact Us</li>
          </ul>
        </section>

        <section class="site-footer__column">
          <h3 class="site-footer__column-title">Follow Us</h3>
          <div class="site-footer__social-group">
            <div class="site-footer__social-link" @click="openLinkedin">
              <img :src="linkedinIcon" class="site-footer__social-badge" alt="">
              <span class="site-footer__social-text">Linkedin</span>
            </div>
          </div>
        </section>

        <section class="site-footer__column">
          <h3 class="site-footer__column-title">About Lemon Check</h3>
          <ul class="site-footer__link-list">
            <li class="site-footer__link-item" @click="navigationTo('/about/about-us')">About Us</li>
            <li class="site-footer__link-item" @click="navigationTo('/about/partner-brand')">Partner Brand Side</li>
            <!-- <li class="site-footer__link-item">Help Center</li>
            <li class="site-footer__link-item">Terms and Conditions</li> -->
          </ul>
        </section>
      </div>

      <!-- <div class="site-footer__divider"></div>

      <div class="site-footer__copyright">
        京公网安备 234924738478248294号 | 京ICP备 8248294号
      </div> -->
    </div>
  </footer>
</div>
</template>

<script>
import checkVinBar from '@/components/CheckVinBar.vue';
import footerIcon1 from '@/assets/images/icon/footer-icon1.png';
import footerIcon2 from '@/assets/images/icon/footer-icon2.png';
import linkedinIcon from '@/assets/images/icon/linkedin-icon.png';
export default {
  name: 'Footer',
  components: {
    checkVinBar
  },
  data() {
    return {
        footerIcon1,
        footerIcon2,
        linkedinIcon,
        // currentRoutePath: this.$route.path,
        showBottomVinCheckUrl: [
            '/',
            '/vehicle-history/introduction',
            '/vehicle-history/vin-introduction',
            '/vehicle-history/how-to-buy',
            '/vehicle-history/vin-check',
            '/sample-reports',
            '/for-business',
            '/about/about-us',
            '/about/partner-brand',
            '/contact-us',
            '/order',
            '/pay'
        ]
    }
  },
  methods: {
    openWhatsApp() {
        let phonenumber = "(+86)13776040570"
        window.open(`whatsapp://send?phone=${phonenumber}`)
        // window.location.href = `whatsapp://send?phone=${phonenumber}`;
        // 设置一个定时器，如果在短时间内页面没有被切到后台，就认为App未安装
        let timer = setTimeout(() => {
            // 跳转到网页版或应用商店
            window.open(`https://wa.me/${phonenumber}`)
        }, 2500);

        // 如果页面被切到后台（App被成功唤起），清除定时器
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) {
                clearTimeout(timer);
            }
        });
    },
    openOutlookApp() {
        window.open('ms-outlook://')
    },
    openLinkedin() {
        window.open("https://www.linkedin.com/company/cada-lemon-check/?viewAsMember=true")
    },
    navigationTo(path) {
        if (this.$route.path != path) {
            this.$router.push(path)
        }
        window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped lang="scss">
.site-footer {
  width: 100%;
  background: #0f1923;

  &__inner {
    width: 1600px;
    margin: 0 auto;
    // padding: 42px 0 20px;
    padding: 42px 0 42px;
  }

  &__navigation {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    column-gap: 32px;
    row-gap: 24px;
    padding: 0 58px;
  }

  &__column {
    font-family: 'Alibaba PuHuiTi 3.0', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  }

  &__column--service {
    min-width: 230px;
  }

  &__column-title {
    height: 25px;
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 0.8);
    white-space: nowrap;
  }

  &__link-list {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  &__link-item {
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  &__contact-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 18px;
  }

  &__contact-label {
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 0.5);
  }

  &__contact-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 20px;
    cursor: pointer;
  }

  &__contact-text {
    font-family: 'Alibaba PuHuiTi 3.0', 'PingFang SC', 'Microsoft YaHei', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 0.5);
    transition: color 0.2s ease;
  }

  &__contact-link:hover &__contact-text {
    color: rgba(255, 255, 255, 0.8);
  }

  &__contact-icon {
    display: inline-flex;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

//   &__contact-icon--whatsapp {
//     background: #34c759;
//   }

//   &__contact-icon--email {
//     background: #4c6fff;
//   }

  &__social-group {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  &__social-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 20px;
    cursor: pointer;
  }

  &__social-badge {
    display: inline-flex;
    width: 56px;
    height: 20px;
    flex-shrink: 0;
  }

  &__social-text {
    font-family: 'Alibaba PuHuiTi 3.0', 'PingFang SC', 'Microsoft YaHei', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 0.5);
    transition: color 0.2s ease;
  }

  &__social-link:hover &__social-text {
    color: rgba(255, 255, 255, 0.8);
  }

  &__divider {
    width: 1440px;
    height: 1px;
    margin: 72px auto 18px;
    background: #f8f9fa;
    opacity: 0.2;
  }

  &__copyright {
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #9da7b8;
  }
}
</style>
